import {Controller} from '@hotwired/stimulus';

// https://codepen.io/andybarefoot/pen/QMeZda
export default class extends Controller {
  static targets = ["item", "container"]

  connect() {
    // Hang onto the bound fn — bind() returns a new one every call, so the old
    // disconnect() was removing a listener that had never been registered.
    this.boundAdjustHeight = this.adjustHeight.bind(this)
    window.addEventListener('resize', this.boundAdjustHeight)
    this.columnCount = 0
    this.itemCount = 0

    this.adjustHeight()
  }

  disconnect() {
    window.removeEventListener('resize', this.boundAdjustHeight)
  }

  // Catches cards that weren't reachable yet when connect() ran.
  itemTargetConnected() {
    this.adjustHeight()
  }

  adjustHeight() {
    const newColumnCount = parseInt(getComputedStyle(this.element).columnCount, 10)
    const items = this.itemTargets

    // Don't clear innerHTML unless there's something to put back or it deletes
    // every post on the page. Bailing is harmless: columns-* does the layout,
    // this only changes reading order.
    //
    // Repro, if you're wondering whether this is still needed: Safari only —
    // desktop, or anything on iOS. Wifi or cellular, cellular's easiest.
    // Private window, and bump a query string each load (/blog?x=1, ?x=2) since
    // bfcache restores without re-running JS. Only prod + desktop Safari + wifi
    // stayed clean, over 90 loads.
    if (!Number.isInteger(newColumnCount) || newColumnCount < 1) return
    if (items.length === 0) return

    // Guards go above this line — cache columnCount on a bail and a later call that
    // CAN see the cards early-returns forever.
    if (this.columnCount === newColumnCount && this.itemCount === items.length) return

    this.columnCount = newColumnCount
    this.itemCount = items.length
    const columns = this.reorderByColumns(items, newColumnCount)
    this.element.innerHTML = ''
    columns.forEach((column) => this.element.appendChild(column))
  }

  reorderByColumns(items, columns) {
    const sortedItems = items.sort((a, b) => {
      return parseInt(a.dataset.index, 10) - parseInt(b.dataset.index, 10)
    })
    return Array.from({ length: columns }).reduce((result, _, col) => {
      const div = document.createElement("div")
      div.classList.add("break-inside-avoid")
      sortedItems.forEach((item, index) => {
        if (index % columns === col) {
          div.appendChild(item);
        }
      })
      result.push(div)
      return result
    }, [])
  }
}
